import {http} from "./index";

class AuthService {

    login(data) {
        return http.post("/auth/login", data);
    }

    logout() {
        return http.get(`/auth/logout`);
    }

    register(data) {
        return http.post(`/auth`, data);
    }

    isLogged(){
        return http.get(`/auth/isLogged`);
    }

    requestPasswordReset(data) {
         return http.post(`/auth/reset_request`, data);
    }

    confirmPasswordReset(token, data) {
        return http.post(`/auth/reset/${token}`, data);
    }

}

export default AuthService;
